import { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  pt: {
    tagline: "A memória operacional da empresa.",
    hero_title: "Sua empresa fala. A Isa lembra de tudo.",
    hero_sub: "Voz, texto, PDF, imagem — tudo pelo WhatsApp vira conhecimento estruturado, com autoria, versão e memória permanente. O Comercial é só o começo.",
    cta_demo: "Quero uma demo",
    cta_login: "Entrar",
    cta_start: "Começar agora",
    login: "Entrar", register: "Criar conta", logout: "Sair",
    email: "E-mail", password: "Senha", company: "Empresa", your_name: "Seu nome",
    overview: "Visão geral", pipeline: "Pipeline", accounts: "Contas", brain: "Cérebro",
    team: "Equipe", audit: "Auditoria", simulator: "Simulador WhatsApp", profiles: "Perfis",
    pipeline_value: "Valor em pipeline", open_opps: "Oportunidades abertas",
    won_value: "Fechado (ganho)", accounts_count: "Contas",
    hot_accounts: "Contas mais quentes", suggestions: "Sugestões proativas",
    weekly: "Gerar resumo da semana", timeline: "Linha do tempo",
    documents: "Documentos", contacts: "Contatos", version: "versão", status: "status",
    pending: "Pendências",
    integrations: "Integrações",
    agenda: "Agenda",
    add_knowledge: "Adicionar ao cérebro", title: "Título", content: "Conteúdo", scope: "Camada",
    add_employee: "Adicionar funcionário", name: "Nome", phone: "WhatsApp", role: "Papel",
    send: "Enviar", type_msg: "Digite como se fosse o WhatsApp...", from_number: "Enviar como",
    no_records: "Sem registros", loading: "Carregando...",
  },
  en: {
    tagline: "The company's operational memory.",
    hero_title: "Your company speaks. Isa remembers everything.",
    hero_sub: "Voice, text, PDF, image — everything through WhatsApp becomes structured knowledge, with authorship, versioning and permanent memory. Sales is just the start.",
    cta_demo: "I want a demo",
    cta_login: "Log in",
    cta_start: "Get started",
    login: "Log in", register: "Sign up", logout: "Log out",
    email: "Email", password: "Password", company: "Company", your_name: "Your name",
    overview: "Overview", pipeline: "Pipeline", accounts: "Accounts", brain: "Brain",
    team: "Team", audit: "Audit", simulator: "WhatsApp Simulator", profiles: "Profiles",
    pipeline_value: "Pipeline value", open_opps: "Open opportunities",
    won_value: "Closed (won)", accounts_count: "Accounts",
    hot_accounts: "Hottest accounts", suggestions: "Proactive suggestions",
    weekly: "Generate weekly summary", timeline: "Timeline",
    documents: "Documents", contacts: "Contacts", version: "version", status: "status",
    pending: "Pending",
    integrations: "Integrations",
    agenda: "Agenda",
    add_knowledge: "Add to brain", title: "Title", content: "Content", scope: "Layer",
    add_employee: "Add employee", name: "Name", phone: "WhatsApp", role: "Role",
    send: "Send", type_msg: "Type as if on WhatsApp...", from_number: "Send as",
    no_records: "No records", loading: "Loading...",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("radar_lang") || "pt");
  const t = useCallback((k) => DICT[lang][k] || DICT.pt[k] || k, [lang]);
  const toggle = () => {
    const next = lang === "pt" ? "en" : "pt";
    setLang(next);
    localStorage.setItem("radar_lang", next);
  };
  return <I18nCtx.Provider value={{ lang, t, toggle }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
